import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/admin/zipcode";

export default {
  getInfo: (zipcode) =>
    bffServiceInstance.get(`${prefix}/get-info`, { zipcode }),
};
